import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'
import { getMinutesSecondsTime } from '../../../common/utils/time'
import ClockIcon from '../icons/clock'
import SearchIcon from '../icons/search'

class FiltersLength extends React.Component {
  static propTypes = {
    length: PropTypes.object,
    location: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    const { location: { query } } = props
    this.state = {
      lengthMin: getMinutesSecondsTime(query.length_min),
      lengthMax: getMinutesSecondsTime(query.length_max)
    }
  }

  onLengthMinChange(event) {
    this.setState({ lengthMin: event.target.value })
  }

  onLengthMaxChange(event) {
    this.setState({ lengthMax: event.target.value })
  }

  onSubmit() {
    const parsedLocation = parseLocation(this.props.location)

    let nextQuery = Object.assign({}, parsedLocation, {
      length_min: getMinutesSecondsTime(this.state.lengthMin),
      length_max: getMinutesSecondsTime(this.state.lengthMax)
    })

    delete nextQuery.page

    if (!this.state.lengthMin) {
      delete nextQuery.length_min
    }

    if (!this.state.lengthMax) {
      delete nextQuery.length_max
    }

    this.props.history.push(makeLink(nextQuery))
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextQuery = nextProps.location.query

    if (nextQuery.length_min !== this.state.lengthMin) {
      this.setState({ lengthMin: getMinutesSecondsTime(nextQuery.length_min) })
    }

    if (nextQuery.length_max !== this.state.lengthMax) {
      this.setState({ lengthMax: getMinutesSecondsTime(nextQuery.length_max) })
    }
  }

  render() {
    const { isAtTop } = this.props
    const searchFacetBoxClassNames = classNames({
      'search-facet-box': !isAtTop,
      'search-facet-box--start': isAtTop
    })

    return (
      <div className="search-facet--no-margin" id="length-filter">
        <div className={searchFacetBoxClassNames}>
          <div className="search-facet-box__inner">
            <h2 className="search-facet-box__heading">
              <ClockIcon /> Length
            </h2>
            <div className="search-facet-range__inputs">
              <div className="search-facet-range__input">
                <label>Length</label>
                <input
                  type="text"
                  className="e-input"
                  placeholder={
                    this.props.length
                      ? getMinutesSecondsTime(this.props.length.min)
                      : ''
                  }
                  value={this.state.lengthMin}
                  onChange={this.onLengthMinChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input">
                <label>To</label>
                <input
                  type="text"
                  className="e-input"
                  placeholder={
                    this.props.length
                      ? getMinutesSecondsTime(this.props.length.max)
                      : ''
                  }
                  value={this.state.lengthMax}
                  onChange={this.onLengthMaxChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input--submit">
                <button
                  type="button"
                  className="fds-c-button fds-u-p0 no-label"
                  onClick={this.onSubmit.bind(this)}
                >
                  <SearchIcon title="Apply" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const FiltersLengthComponent = FiltersLength
export default withRouter(FiltersLength)



// WEBPACK FOOTER //
// ./client/components/filters/filtersLength.js